import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface stateType {
  pause: boolean;
  count: number;
}

const initialState: stateType = {
  pause: false,
  count: 0,
};

export const game = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setPause(state, action: PayloadAction<boolean>) {
      state.pause = action.payload;
    },
    incrementCount(state) {
      state.count = state.count + 1;
    },
    resetCount(state) {
      state.count = 0;
    },
  },
});

export const {
  incrementCount,
  resetCount,
  setPause,
} = game.actions;

export default game.reducer;
